import Footer from "@/layouts/footer";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import FAQ from "./components/faq";
import NavPage from "@/layouts/nav-header";
function AboutUsPage() {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const sections = [
    {
      title: t("about.section3_step1_title"),
      description: t("about.section3_step1_description"),
    },
    {
      title: t("about.section3_step2_title"),
      description: t("about.section3_step2_description"),
    },
    {
      title: t("about.section3_step3_title"),
      description: t("about.section3_step3_description"),
    },
    {
      title: t("about.section3_step4_title"),
      description: t("about.section3_step4_description"),
    },
  ];
  return (
    <div className="flex flex-col min-h-screen bg-[#f8fafa]">
      <NavPage isForm={0}>
        <div className="flex-grow flex justify-center pt-32 pb-16 px-4 sm:px-8 overflow-auto">
          <main className="flex flex-col items-center justify-center w-full max-w-6xl">
            <section className="bg-white p-8 sm:p-10 rounded-lg shadow-lg w-full">
              <div className="mb-8">
                <h1 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">
                  {t("about.title")}
                </h1>
                <p className="text-sm sm:text-base text-yellow-600">
                  {t("about.section1_title")}
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-2">
                  {t("about.section1_title")}
                </h2>
                <p className="text-gray-700">{t("about.section1_body")}</p>
              </div>

              <div className="mb-8">
                <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-2">
                  {t("about.section2_title")}
                </h2>
                <p className="text-gray-700">{t("about.section2_body")}</p>
                <p className="text-gray-700 mt-2">
                  {t("about.section2_additional")}
                </p>
              </div>

              <div className="mb-8">
                <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-2">
                  {t("about.section3_title")}
                </h2>
                <ul className="list-disc list-inside text-gray-700">
                  {sections.map((step, index) => (
                    <li key={index}>
                      <strong>{step.title}</strong> {step.description}
                    </li>
                  ))}
                </ul>
                <p className="text-gray-700 mt-2">
                  {t("about.section3_summary")}
                </p>
              </div>

              <FAQ />
            </section>
          </main>
        </div>
        <Footer />
      </NavPage>
    </div>
  );
}

export default AboutUsPage;
